import mobile from '@/assets/img/asset-type-icons/mobile.svg'
import desktop from '@/assets/img/asset-type-icons/desktop.svg'
import data from '@/assets/img/asset-type-icons/data.svg'
import document from '@/assets/img/asset-type-icons/doc.svg'
import openEnded from '@/assets/img/asset-type-icons/open_ended.svg'
import audio from '@/assets/img/asset-type-icons/audio.svg'
import video from '@/assets/img/asset-type-icons/video.svg'
import url from '@/assets/img/asset-type-icons/url.svg'
import clientupload from '@/assets/img/asset-type-icons/upload.svg'
import dropbox from '@/assets/img/asset-type-icons/dropbox.png'
import google from '@/assets/img/asset-type-icons/drive.png'

const icoLookup: Record<string, string> = {
  mobile,
  desktop,
  data,
  document,
  textResponses: openEnded,
  'text-slice': openEnded,
  textFrequency: openEnded,
  textComparison: openEnded,
  audio,
  video,
  ut: video,
  url,
  clientupload,
  dropbox,
  google
}
export default icoLookup
